import { render } from "./Initial_questionnaire.vue?vue&type=template&id=65c0860c&scoped=true"
import script from "./Initial_questionnaire.vue?vue&type=script&lang=js"
export * from "./Initial_questionnaire.vue?vue&type=script&lang=js"

import "./Initial_questionnaire.vue?vue&type=style&index=0&id=65c0860c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65c0860c"]])

export default __exports__